import RPPG from './lib/RPPG'

export default RPPG
